/* eslint-disable consistent-return */
import React, { useEffect, useMemo, useState } from 'react';

import io, { Socket } from 'socket.io-client';
import {
  ClientToServerEvents,
  ISocketContext,
  ServerToClientEvents,
} from '../types/socketclient';

interface CustomSocket
  extends Socket<ServerToClientEvents, ClientToServerEvents> {
  username: string;
}

export const SocketContext = React.createContext<ISocketContext | null>(null);
export const SocketProvider: React.FC<{ children: React.ReactElement }> = ({
  children,
}) => {
  const [shouldConnectSocket, setShouldConnectSocket] =
    useState<boolean>(false);
  const [socket, setSocket] = useState<null | Socket<
    ServerToClientEvents,
    ClientToServerEvents
  >>(null);

  useEffect(() => {
    if (shouldConnectSocket) {
      const sessionID = localStorage.getItem('sessionID');
      const newSocket = io(`${process.env.REACT_APP_API_URI}`, {
        transports: ['websocket', 'polling'],
        withCredentials: true,
        auth: {
          sessionID,
        },
      });

      setSocket(newSocket);
      return () => {
        newSocket.disconnect();
      };
    }
  }, [shouldConnectSocket]);

  useEffect(() => {
    if (socket) {
      socket.on('connect', () => {
        console.info('user is connected', socket.id);
      });

      socket.on('connect_error', (error) => {
        console.error(error);
      });
      socket.on('disconnect', () => {
        console.info('Socket Disconnected');
      });
      socket.on('session', ({ sessionID, username }) => {
        socket.auth = { sessionID };
        // store it in the localStorage
        localStorage.setItem('sessionID', sessionID);
        (socket as CustomSocket).username = username;
      });

      return () => {
        socket.off('connect_error');
        socket.off('connect');
        socket.off('session');
      };
    }
  }, [socket]);

  const socketContextProviderValue = useMemo(
    () => ({ socket, shouldConnectSocket, setShouldConnectSocket }),
    [socket, shouldConnectSocket, setShouldConnectSocket]
  );
  return (
    <SocketContext.Provider value={socketContextProviderValue}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
